const Urls = {
	Api: {
		customer: {
			sales_profile: '/my/api/2/customer/sales-manager/profile'
		}
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/private-client-advisor/app.html'
	}
};

export default Urls;